import { initI18n } from 'www/utils'
import I18NextVue from 'i18next-vue'

(async () => {
  const mountElement = document.querySelector('.vue-doctor-service-prices-mount')

  if (!mountElement) {
    return
  }

  const { default: Vue } = await import(/* webpackMode: "eager" */'www/vue_components')
  const { default: vuetify } = await import(/* webpackMode: "eager" */'www/modules/vuetify-plugin-without-reset-scss')
  const { default: DoctorServicePrices } = await import(/* webpackMode: "eager" */'www/vue_components/common/DoctorServicePrices/DoctorServicePrices.vue')

  const { i18next } = await initI18n({ bundle: 'vue_components/common/DoctorServicePrices' })

  Vue.use(I18NextVue, { i18next })

  new Vue({
    vuetify,
    el: mountElement,
    name: 'DoctorServicePricesRoot',
    components: {
      DoctorServicePrices,
    },
  })
})()
